import * as angular from 'angular';
import {ConfigScope} from "./config.base";
import template from './wsiConfig.tpl.html';

export default angular.module('aps.controller.wsiConfig', [])
  .directive('apsWsiConfig', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template,
      link: (scope: ConfigScope) => {
        scope.vm.dataPoints = [];
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/wsiConfig.directive.ts